export enum MedicalOrderRequestChannel {
  CREATE = 'medicalOrderRequest::create',
  EDIT = 'medicalOrderRequest::patch',
  DELETE = 'medicalOrderRequest::delete',
}
